var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickbooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2500px",
    height: "2500px",
    enableBackground: "new -1064.469 -1064.469 2500 2500",
    viewBox: "-1064.5 -1064.5 2500 2500",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.3405 -4.7631)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(108.1 4.4831)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-117.17 25.702)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.726 -185.96)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.165 260.28)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4545 0 0 1.4545 -559 -409.11)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 478.56,
    cy: 340.26,
    r: 859.42,
    fill: "#2CA01C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-142.13 340.26c0 185.25 148.96 334.22 334.22 334.22h47.747v-124.14h-47.747c-116.5 0-210.08-93.585-210.08-210.08s93.58-210.08 210.08-210.08h114.59v649.34c0 68.755 55.388 124.14 124.14 124.14v-897.61h-238.73c-185.25 0-334.22 150.87-334.22 334.22zm907.16-334.22h-47.747v124.14h47.747c116.5 0 210.08 93.581 210.08 210.08 0 116.5-93.58 210.08-210.08 210.08h-114.59v-649.34c0-68.75-55.388-124.14-124.14-124.14v897.62h238.73c185.25 0 334.22-148.97 334.22-334.22 0-183.34-148.97-334.22-334.22-334.22z",
    fill: "#fff"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickbooks);
export default __webpack_public_path__ + "static/media/quickbooks.9a02c4e92671b82231e4b9037eff060b.svg";
export { ForwardRef as ReactComponent };